export default "__VITE_ASSET__Br$Nlpkr__"